// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PLAN_CERTIFICATE_COMPILE_MODAL_CHANGE,
} from './constants';

export function certificateCompileModalChange(visible,message) {
  return {
    type: PLAN_CERTIFICATE_COMPILE_MODAL_CHANGE,
    data:{visible,message}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_CERTIFICATE_COMPILE_MODAL_CHANGE:
      return {
        ...state,
        certificateCompileModalVisible:action.data.visible,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/certificateCompileModalChange.js